import PropTypes from 'prop-types';

import {emitUrgencyUnitMessageEvent} from '../../../helpers/edap';
import BaseUrgencyMessage from '../../../BaseUrgencyMessage/BaseUrgencyMessage';

const BASE_CLASS = 'UrgencyUnitMessage';
export default class UnitMessageComponent extends BaseUrgencyMessage {
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        unitMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                }),
            }),
            PropTypes.shape({
                iconTextV2: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                }),
            }),
            PropTypes.shape({
                iconText: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                }),
            })
        ]),
        /** If true, changes small greyscale icon to its color variant */
        color: PropTypes.bool,
        /** Set to true in order to hide the component from screen readers */
        ariaHidden: PropTypes.bool
    };

    componentDidMount() {
        const {messageValueType} = UnitMessageComponent.getUnitMessageContent(this.props.unitMessage);
        if (messageValueType) {
            emitUrgencyUnitMessageEvent(this.context, messageValueType);
        }
    }

    // eslint-disable-next-line complexity
    static getUnitMessageContent(unitMessage) {
        if (unitMessage) {
            const {iconTextV1, iconTextV2, iconText} = unitMessage;
            return iconTextV1 || iconTextV2 || iconText || {};
        }
        return {};
    }

    render() {
        const unitMessageContent = UnitMessageComponent.getUnitMessageContent(this.props.unitMessage);
        const baseClass = BASE_CLASS;
        return this.generateComponent({baseClass, ...this.props}, unitMessageContent);
    }
}
